import { createRouter, createWebHistory } from 'vue-router'
import RegistrationView from '../views/Registration.vue'
import VerificationView from '../views/Verification.vue'

const routes = [
  // {
  //   path: '/',
  //   name: 'HomeView',
  //   component: HomeView
  // },
  {
    path: '/register',
    name: 'RegistrationView',
    component: RegistrationView
  },
  {
    path: '/',
    name: 'VerificationView',
    component: VerificationView
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router 